import { render, staticRenderFns } from "./ChangeDisplayOrder.vue?vue&type=template&id=e5f1b388&scoped=true&"
import script from "./ChangeDisplayOrder.vue?vue&type=script&lang=ts&"
export * from "./ChangeDisplayOrder.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeDisplayOrder.vue?vue&type=style&index=0&id=e5f1b388&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5f1b388",
  null
  
)

export default component.exports